require('../../styles/blocks/_roadmap-navigation.scss');
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
import { formatText } from 'core/i18n';
import { LoadingDots } from 'commonsComponents/loadingDots';

const stepsActions = require('actions/stepsActions');
const modalCancelActions = require('actions/modalCancelActions');

class RoadmapNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.handlePrevStep = this.handlePrevStep.bind(this);
        this.handleModal = this.handleModal.bind(this);
    }

    handlePrevStep() {
        const currentStep = this.props.immStepsState.get('currentStep');

        this.props.stepsActions.changeCurrentStep({
            index: parseInt(currentStep) - 1,
        });
    }

    handleModal() {
        this.props.modalCancelActions.showModalCancel();
    }

    buildLoadingButton() {
        const buttonClass = 'form__button form__button-primary form__button-progress-roadmap-navigation';

        return (
            <a className={buttonClass}>
                <span className="circle circle-1"></span>
                <span className="circle circle-2"></span>
                <span className="circle circle-3"></span>
            </a>
        );
    }

    render() {
        const {
            buttonCancelHidden,
            buttonPrevHidden,
            buttonPrevSpecialHidden,
            buttonFinalizeHidden,
            buttonContinueDisabled,
            buttonPrevAction,
            buttonContinueType,
            buttonContinueAction,
            buttonContinueClass,
            buttonContinueText,
            buttonContinueLoading,
            buttonFinalizeDisabled,
            style,
            buttonPrevText,
            buttonCancelText,
            buttonCancelAction,
            buttonFinalizeText,
            buttonFinalizeAndContinueHidden,
            buttonContinueFakeDisabled,
            buttonFinalizeFakeDisabled,
            stepFooter,
            isButtonContinueLoading,
        } = this.props;
        const classButtonCancel = buttonCancelHidden ? 'hidden' : 'form__button roadmap-navigation__button-cancel';
        const classButtonPrev = buttonPrevHidden
            ? 'hidden'
            : 'form__button form__button-negative roadmap-navigation__button-prev';
        const classButtonPrevSpecial = buttonPrevSpecialHidden
            ? 'hidden'
            : 'form__button form__button-negative roadmap-navigation__button-prev';
        const classButtonFinalize =
            buttonFinalizeHidden || buttonFinalizeAndContinueHidden
                ? 'hidden'
                : `form__button form__button-secondary roadmap-navigation__button-continue roadmap-navigation__button-finalize ${
                      buttonFinalizeFakeDisabled ? 'disable-styles' : ''
                  }`;
        const classButtonContinue =
            !buttonFinalizeHidden || buttonFinalizeAndContinueHidden
                ? 'hidden'
                : `${buttonContinueClass} ${buttonContinueFakeDisabled ? 'disable-styles' : ''}`;
        const buttonPrevFunc = buttonPrevAction ? buttonPrevAction : this.handlePrevStep;
        const buttonCancelFunc = buttonCancelAction ? buttonCancelAction : this.handleModal;
        let buttonContinue = (
            <button
                className={classButtonContinue}
                disabled={buttonContinueDisabled}
                type={buttonContinueType}
                onClick={buttonContinueAction}
            >
                {isButtonContinueLoading ? <LoadingDots inline size="large" color="dark" /> : buttonContinueText}
            </button>
        );

        if (buttonContinueLoading) {
            buttonContinue = this.buildLoadingButton();
        }

        return (
            <div style={style} className={`form__buttons roadmap-navigation ${stepFooter && 'step-footer'}`}>
                <button className={classButtonCancel} type="button" onClick={buttonCancelFunc}>
                    {buttonCancelText}
                </button>
                <button className={classButtonPrev} type="button" onClick={buttonPrevFunc}>
                    {buttonPrevText}
                </button>
                <button className={classButtonPrevSpecial} type="button" onClick={buttonPrevAction}>
                    {formatText('button-prev')}
                </button>
                {buttonContinue}
                <button
                    className={classButtonFinalize}
                    disabled={buttonFinalizeDisabled}
                    type={buttonContinueType}
                    onClick={buttonContinueAction}
                >
                    {buttonFinalizeText}
                </button>
            </div>
        );
    }
}

RoadmapNavigation.defaultProps = {
    buttonCancelHidden: false,
    buttonPrevHidden: false,
    buttonPrevSpecialHidden: true,
    buttonFinalizeHidden: true,
    buttonContinueLoading: false,
    buttonContinueDisabled: false,
    buttonContinueType: 'button',
    buttonContinueAction: null,
    buttonContinueClass: 'form__button form__button-primary roadmap-navigation__button-continue',
    buttonContinueText: formatText('button-continue'),
    isButtonContinueLoading: false,
    buttonPrevAction: null,
    style: {},
    buttonPrevText: formatText('button-prev'),
    buttonCancelText: formatText('button-exit'),
    buttonFinalizeText: formatText('button-finalize'),
    buttonFinalizeAndContinueHidden: false,
    buttonFinalizeDisabled: false,
    stepFooter: false,
};
module.exports.constructor = RoadmapNavigation;
module.exports.RoadmapNavigation = connect(
    state => ({
        modalCancel: state.modalCancel,
        immStepsState: state.steps,
    }),
    dispatch => ({
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
    })
)(RoadmapNavigation);
